import { useMemo } from 'react';

// Services
import { useGlobalFilters as useGlobalFiltersService } from '../../services/globalFilters/globalFiltersQueries';

// UseCase
import { getGlobalFiltersKey } from './globalFiltersUseCase';

/**
 * @typedef {object} UseGlobalFiltersReturn
 * @property {GlobalFiltersKey | null} globalFiltersKey - The global filters key
 * @property {boolean} isGlobalFiltersFetched - True once the global filters query has settled (success or error)
 */

/**
 * Custom hook to get the global filters
 * @param {{ path: string }} params - The parameters
 * @returns {UseGlobalFiltersReturn} The global filters
 */
const useGlobalFilters = ({
  path,
}) => {
  const {
    data: managerGlobalFilters,
    isFetched: isGlobalFiltersFetched,
  } = useGlobalFiltersService({ path }, { enabled: !!path });

  const globalFiltersKey = useMemo(
    () => getGlobalFiltersKey(managerGlobalFilters),
    [managerGlobalFilters],
  );

  return {
    globalFiltersKey,
    isGlobalFiltersFetched,
  };
};

export default useGlobalFilters;
